import styled, { css } from "styled-components"

export const Svg = styled.svg`
  height: 100%;
  transform: rotate(-.25turn);
`
export const fillable = css`
  fill: ${props => props.fillColor};
  transition: fill 0.3s;
`
export const CircularSector = styled.path`
  ${fillable}
`
export const Circle = styled.circle`
  ${fillable}
`